import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteAppointment = (onSuccess) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while deleting appointment");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/appointment/delete`,
        {
          data: {
            id: Number(id),
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Appointment deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
      queryClient.invalidateQueries({ queryKey: ["monthSlotCounts"] });
      onSuccess?.();
    },
    onError: handleNetworkError,
  });
};
